import { Component } from "preact";
class CheckboxPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            values: {},
        };
        this.onCheckboxChanged = this.onCheckboxChanged.bind(this);
        this.createOptions = this.createOptions.bind(this);
    }



    createOptions(properties) {
        let options = {};
        properties.values.forEach((x) => {
            options[x] = properties.checkedValues.includes(x);
        });

        this.setState({ values: options });
        this.state;
    }

    componentWillMount() {
        this.setState({ values: {} });
        this.createOptions(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ values: {} });
        this.createOptions(nextProps);
    }

    onCheckboxChanged(name) {
        let newState = { ...this.state };
        newState.values[name] = !this.state.values[name];
        this.setState(newState);

        const checked = Object.keys(this.state.values).filter(
            (x) => this.state.values[x] === true
        );
        this.props.onChange(checked);
    }

    render({
        renderTitle,
        renderValue,
        getOptionGtmId,
        getOptionGA4Id,
        getOptionGa4ThirdTrackingId,
        getGa4Name,
        containerClass = "",
        valueClass = "",
        labelClass = "",
    }) {
        return (
            <div class={containerClass}>
                {renderTitle()}
                {Object.keys(this.state.values).map((key) => {
                    const thirdTrackingId = getOptionGa4ThirdTrackingId ? getOptionGa4ThirdTrackingId(key) : null;
                    return (
                        <label key={key} class={labelClass}>
                            <input
                                key={key}
                                class={valueClass}
                                type="checkbox"
                                data-gtmid={getOptionGtmId && getOptionGtmId(key)}
                                data-ga4event-clk-name={getGa4Name && getGa4Name}
                                data-ga4event-element={getOptionGA4Id && getOptionGA4Id(key)}
                                {...thirdTrackingId}
                            checked={this.state.values[key]}
                            onChange={() => this.onCheckboxChanged(key)}
                            />

                            {renderValue(key)}
                        </label>
                    )
                })}
            </div>
        );
    }
}
export default CheckboxPicker;
